<div class="c-avatar_info color-white">


  <ng-container>
    <button mat-button class=" color-white font-14 u-capitalize outline-none"
            [matMenuTriggerFor]="menu" id="notify_button" tabindex="-1"
            aria-label="Notificaciones">
      <span>
        <app-sample-material-icon [iconName]="'notifications'" aria-hidden="true"></app-sample-material-icon>
      </span>
      <span *ngIf="(counterRequest || counterRequestDefault)" class="notify-border color-blue background-yellow" aria-hidden="true">
        <!-- {{counterRequest + counterRequestDefault}} -->
        !
      </span>
    </button>
  </ng-container>



  <mat-menu #menu="matMenu">
    <div class="padding-box">

      <h4>Notificaciones</h4>
      <hr>
      <ul>
        <li *ngIf="(counterRequest)">
          <app-sample-material-icon style="color: #db7800" [iconName]="'error'"></app-sample-material-icon> Conoce
          <span>
            <a (click)="goToNews()" appDebounceClick [analyticsModel]="{'event':'ga_event','category':'Titulo Notificaciones','action':'clic_notificacion','label':'Notificaciones'}" class=" text-underline" id = "notification-model-here" aria-label="Conoce Aqui novedades sobre la solicitud del Subsidio Familiar">
              <span aria-hidden="true">Aqui</span>
            </a>
          </span>
          novedades sobre la solicitud del Subsidio Familiar
        </li>
        <li *ngIf="(counterRequestDefault)">
          <app-sample-material-icon style="color: #db7800" [iconName]="'error'"></app-sample-material-icon>
            <a
              appDebounceClick [analyticsModel]="{'event':'ga_event','category':'Titulo Notificaciones','action':'clic_notificacion','label':'Notificaciones'}"
              (click)="goToNewsDefault()" class=" text-underline" id = "notification-model-here" aria-label="Conoce Aqui novedades sobre la solicitud del Subsidio Familiar">
              <span aria-hidden="true">Conoce Aqui novedades sobre tus solicitudes</span>
            </a>
        </li>
      </ul>

    </div>
  </mat-menu>
</div>
